import { Preferences } from '@capacitor/preferences';
import { dom } from './dom.js';

// Available sizes: 'sm', 'md', 'lg'
const FONT_SIZE_KEY = 'fontSize';

/**
 * Apply font size class to html element
 * @param {string} size 'sm' | 'md' | 'lg'
 */
export function applyFontSize(size) {
    // Remove all existing font size classes
    document.documentElement.classList.remove('font-size-sm', 'font-size-lg'); // 'md' is default (no class)

    if (size === 'sm') {
        document.documentElement.classList.add('font-size-sm');
    } else if (size === 'lg') {
        document.documentElement.classList.add('font-size-lg');
    }

    // Update UI active state if DOM is ready
    updateFontSizeUI(size);
}

function updateFontSizeUI(size) {
    if (!dom.fontSizeOptions) return;

    dom.fontSizeOptions.forEach(btn => {
        const btnSize = btn.dataset.size;
        const checkIcon = btn.querySelector('.check-icon');
        
        // Reset check icon
        if (checkIcon) checkIcon.classList.add('hidden');
        
        // Apply active check icon
        if (btnSize === size) {
            if (checkIcon) checkIcon.classList.remove('hidden');
        }
    });
}

/**
 * Set font size and save to preferences
 * @param {string} size 
 */
export async function setFontSize(size) {
    if (!['sm', 'md', 'lg'].includes(size)) return;
    
    await Preferences.set({
        key: FONT_SIZE_KEY,
        value: size
    });
    
    applyFontSize(size);
}

/**
 * Initialize font size from preferences
 */
export async function initializeFontSize() {
    const { value } = await Preferences.get({ key: FONT_SIZE_KEY });
    // Default to 'md' if not set
    const size = value || 'md';
    applyFontSize(size);

    // Bind events
    if (dom.openFontSettingsBtn) {
        dom.openFontSettingsBtn.addEventListener('click', () => {
            if (dom.fontSettingsView) {
                // Hide user settings view to prevent overlap
                if (dom.userSettingsView) dom.userSettingsView.style.display = 'none';
                
                dom.fontSettingsView.style.display = 'flex';
                // Add animation class if needed
                if (dom.fontSettingsContent) {
                    dom.fontSettingsContent.classList.add('view-animate');
                }
            }
        });
    }

    if (dom.backFromFontBtn) {
        dom.backFromFontBtn.addEventListener('click', () => {
            if (dom.fontSettingsView) {
                dom.fontSettingsView.style.display = 'none';
                // Restore user settings view
                if (dom.userSettingsView) dom.userSettingsView.style.display = 'flex';
            }
        });
    }

    if (dom.fontSizeOptions) {
        dom.fontSizeOptions.forEach(btn => {
            btn.addEventListener('click', () => {
                const newSize = btn.dataset.size;
                setFontSize(newSize);
                
                // Behavior consistency: Auto go back to settings like language selection
                if (dom.fontSettingsView) {
                    dom.fontSettingsView.style.display = 'none';
                    if (dom.userSettingsView) dom.userSettingsView.style.display = 'flex';
                }
            });
        });
    }
}